module.exports = __webpack_public_path__ + "static/media/ssn.f09bc0fc.svg";